module.exports = __webpack_public_path__ + "static/media/data-science.b368ee15.svg";